"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _pageManager = _interopRequireDefault(require("./page-manager"));
var _bwaDeliveryPill = _interopRequireDefault(require("../components/bwa-delivery-pill/bwa-delivery-pill"));
var _bwaDeliveryBlock = _interopRequireDefault(require("../components/bwa-delivery-block/bwa-delivery-block"));
var _productReviews = _interopRequireDefault(require("../components/reviews/product-reviews"));
var _validate = require("../apis/bwa/validate");
var _productRatings = _interopRequireDefault(require("../components/ratings/product-ratings"));
var _constants = require("../constants/constants");
var _utils = require("../utils/utils");
var _cartGaEventHandler = _interopRequireDefault(require("../events/cart-ga-event-handler"));
var _pdpGaEventHandler = _interopRequireDefault(require("../events/pdp-ga-event-handler"));
var _variantWatcher = _interopRequireDefault(require("../events/variant-watcher"));
var _productRatingsWatcher = _interopRequireDefault(require("../events/product-ratings-watcher"));
var _productReviewsWatcher = _interopRequireDefault(require("../events/product-reviews-watcher"));
var _bwaPoweredByAmazon = _interopRequireDefault(require("../components/bwa-powered-by-amazon/bwa-powered-by-amazon"));
var _bwaCheckoutButton = _interopRequireDefault(require("../components/bwa-checkout-button/bwa-checkout-button"));
var _bwaBuyNowButton = _interopRequireDefault(require("../components/bwa-buy-now-button/bwa-buy-now-button"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PDPPage = /*#__PURE__*/function (_PageManager) {
  function PDPPage() {
    (0, _classCallCheck2["default"])(this, PDPPage);
    return _callSuper(this, PDPPage);
  }
  (0, _inherits2["default"])(PDPPage, _PageManager);
  return (0, _createClass2["default"])(PDPPage, [{
    key: "onPageLoad",
    value: function () {
      var _onPageLoad = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var storeId, variantId, validateSkuResponse, _validateSkuResponse, _validateSkuResponse2, _validateSkuResponse3;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Shared perceived-latency anchor so every widget's *_perceived event derives its
              // marks from the same page-load baseline.
              window.__bwaPerf = window.__bwaPerf || {};
              window.__bwaPerf.tScript = performance.now();
              _pdpGaEventHandler["default"].attachEvents();
              _cartGaEventHandler["default"].attachEvents();
              _variantWatcher["default"].init();
              _productRatingsWatcher["default"].init();
              _productReviewsWatcher["default"].init();
              storeId = window.storeId;
              variantId = (0, _utils.getVariantId)(window.bwaMerchantConfig.bwaDeliveryBlock.variantIdSelector);
              sessionStorage.removeItem(_constants.SESSION_STORAGE_KEYS.IS_BWA_SKU);
              _context.prev = 10;
              _context.next = 13;
              return (0, _validate.validateSku)(storeId, variantId);
            case 13:
              validateSkuResponse = _context.sent;
              window.__bwaPerf.tValidated = performance.now();
              window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_PRODUCT_VIEWED, {
                detail: {
                  bwaEnabled: (_validateSkuResponse = validateSkuResponse) === null || _validateSkuResponse === void 0 ? void 0 : _validateSkuResponse.isSkuEnabled,
                  reviewsEnabled: (_validateSkuResponse2 = validateSkuResponse) === null || _validateSkuResponse2 === void 0 ? void 0 : _validateSkuResponse2.isReviewsSkuEnabled,
                  ratingsEnabled: (_validateSkuResponse3 = validateSkuResponse) === null || _validateSkuResponse3 === void 0 ? void 0 : _validateSkuResponse3.isRatingsSkuEnabled
                }
              }));
              // Fired for every cohort, including `bwa_checkout_none` (bwaOfferings.CHECKOUT = false),
              // so the PDP step is comparable across cohorts. Consumers segment on the
              // exp_bwa_experience event parameter rather than on the event's presence.
              window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.VIEW_BWA_CHECKOUT_SKU));
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](10);
              console.error('Error in validate SKU call:', _context.t0);
            case 22:
              new _bwaDeliveryBlock["default"](validateSkuResponse);
              new _bwaDeliveryPill["default"]();
              new _bwaCheckoutButton["default"]();
              new _bwaBuyNowButton["default"](validateSkuResponse);
              new _bwaPoweredByAmazon["default"](validateSkuResponse);
              new _productRatings["default"](validateSkuResponse);
              new _productReviews["default"](validateSkuResponse);
              this.attachListenersForNativeAddToCartButton();
            case 30:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[10, 19]]);
      }));
      function onPageLoad() {
        return _onPageLoad.apply(this, arguments);
      }
      return onPageLoad;
    }()
  }, {
    key: "attachListenersForNativeAddToCartButton",
    value: function attachListenersForNativeAddToCartButton() {
      var _window$bwaMerchantCo, _window$bwaMerchantCo2;
      var otherAddToCartButtonSelectors = (_window$bwaMerchantCo = (_window$bwaMerchantCo2 = window.bwaMerchantConfig) === null || _window$bwaMerchantCo2 === void 0 || (_window$bwaMerchantCo2 = _window$bwaMerchantCo2.bwaAddToCartButton) === null || _window$bwaMerchantCo2 === void 0 ? void 0 : _window$bwaMerchantCo2.otherAddToCartButtonSelectors) !== null && _window$bwaMerchantCo !== void 0 ? _window$bwaMerchantCo : [];
      otherAddToCartButtonSelectors === null || otherAddToCartButtonSelectors === void 0 || otherAddToCartButtonSelectors.forEach(function (selector) {
        return (0, _utils.safeQuerySelectorAll)(selector).forEach(function (element) {
          element.addEventListener('click', /*#__PURE__*/function () {
            var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(e) {
              return _regenerator["default"].wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.IS_BWA_SKU) === _constants.SESSION_STORAGE_VALUES.TRUE) {
                      window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.NATIVE_ADD_TO_CART_BUTTON_SUBMIT));
                    }
                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        });
      });
    }
  }]);
}(_pageManager["default"]);
var _default = exports["default"] = PDPPage;
//# sourceMappingURL=pdp.js.map
